import Sign from './modules/sign'
export default new Vuex.Store({
    modules: {
        Sign,
    }
})


// WEBPACK FOOTER //
// ./src/base/vuex/index.js